export default __webpack_public_path__ + "static/media/tq-powered-by-logo.a326e6cb.svg";